import { LayoutState } from "../layout.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { ProgressBarLayout } from "../types/progress-bar.ts";

export const setProgressBarReducer = (
  state: LayoutState,
  action: PayloadAction<ProgressBarLayout>,
) => {
  state.progressBar = action.payload;
};
